var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCalendarGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24645_63997)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.625 2.8125H3.375C2.44302 2.8125 1.6875 3.56802 1.6875 4.5V14.625C1.6875 15.557 2.44302 16.3125 3.375 16.3125H14.625C15.557 16.3125 16.3125 15.557 16.3125 14.625V4.5C16.3125 3.56802 15.557 2.8125 14.625 2.8125Z",
    stroke: "#71758F",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4062 9C10.8722 9 11.25 8.62224 11.25 8.15625C11.25 7.69026 10.8722 7.3125 10.4062 7.3125C9.94026 7.3125 9.5625 7.69026 9.5625 8.15625C9.5625 8.62224 9.94026 9 10.4062 9Z",
    fill: "#71758F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2188 9C13.6847 9 14.0625 8.62224 14.0625 8.15625C14.0625 7.69026 13.6847 7.3125 13.2188 7.3125C12.7528 7.3125 12.375 7.69026 12.375 8.15625C12.375 8.62224 12.7528 9 13.2188 9Z",
    fill: "#71758F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4062 11.8125C10.8722 11.8125 11.25 11.4347 11.25 10.9688C11.25 10.5028 10.8722 10.125 10.4062 10.125C9.94026 10.125 9.5625 10.5028 9.5625 10.9688C9.5625 11.4347 9.94026 11.8125 10.4062 11.8125Z",
    fill: "#71758F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2188 11.8125C13.6847 11.8125 14.0625 11.4347 14.0625 10.9688C14.0625 10.5028 13.6847 10.125 13.2188 10.125C12.7528 10.125 12.375 10.5028 12.375 10.9688C12.375 11.4347 12.7528 11.8125 13.2188 11.8125Z",
    fill: "#71758F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.78125 11.8125C5.24724 11.8125 5.625 11.4347 5.625 10.9688C5.625 10.5028 5.24724 10.125 4.78125 10.125C4.31526 10.125 3.9375 10.5028 3.9375 10.9688C3.9375 11.4347 4.31526 11.8125 4.78125 11.8125Z",
    fill: "#71758F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.59375 11.8125C8.05974 11.8125 8.4375 11.4347 8.4375 10.9688C8.4375 10.5028 8.05974 10.125 7.59375 10.125C7.12776 10.125 6.75 10.5028 6.75 10.9688C6.75 11.4347 7.12776 11.8125 7.59375 11.8125Z",
    fill: "#71758F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.78125 14.625C5.24724 14.625 5.625 14.2472 5.625 13.7812C5.625 13.3153 5.24724 12.9375 4.78125 12.9375C4.31526 12.9375 3.9375 13.3153 3.9375 13.7812C3.9375 14.2472 4.31526 14.625 4.78125 14.625Z",
    fill: "#71758F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.59375 14.625C8.05974 14.625 8.4375 14.2472 8.4375 13.7812C8.4375 13.3153 8.05974 12.9375 7.59375 12.9375C7.12776 12.9375 6.75 13.3153 6.75 13.7812C6.75 14.2472 7.12776 14.625 7.59375 14.625Z",
    fill: "#71758F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4062 14.625C10.8722 14.625 11.25 14.2472 11.25 13.7812C11.25 13.3153 10.8722 12.9375 10.4062 12.9375C9.94026 12.9375 9.5625 13.3153 9.5625 13.7812C9.5625 14.2472 9.94026 14.625 10.4062 14.625Z",
    fill: "#71758F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 1.6875V2.8125M13.5 1.6875V2.8125",
    stroke: "#71758F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3125 5.625H1.6875",
    stroke: "#71758F",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24645_63997"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendarGrey);
export default __webpack_public_path__ + "static/media/icon-calendar-grey.f62498b4ad5ff396806027930f4d22f1.svg";
export { ForwardRef as ReactComponent };